import React from 'react';
import PropTypes from 'prop-types';
import FormDialog from '../../../../Components/Modal/modal';
import './employeeViewAward.scss';
import { Card, Tooltip, Typography } from '@mui/material';
import { CANCEL_TEXT } from '../../../../Constants/strings';

const ViewAward = ({ modalOpen, handleClose, selectedAward }) => {
  return (
    <FormDialog
      open={modalOpen}
      title={
        <span>
          <span className="award-name-title">{selectedAward.award_name}</span>
          <span className="award-year-title">
            {' '}
            {` - ${selectedAward.year}`}
          </span>
        </span>
      }
      PaperProps={{}}
      dialogPaperCss="view-award-paper"
      dialogCss="view-award-dialog"
      dialogBodycontent={
        <div className="award-dialog-body">
          <div
            key={selectedAward.award_id}
            className="view-award-carousel-item"
          >
            <Card>
              <Tooltip
                title={selectedAward.award_name}
                classes={{ tooltip: 'map-role-btn-tooltip' }}
                disableHoverListener={selectedAward?.award_name?.length < 20}
              >
                <Tooltip>
                  <Typography className="award-name">
                    {selectedAward?.award_name?.length > 20
                      ? `${selectedAward.award_name.substring(0, 20)}...`
                      : selectedAward.award_name}
                  </Typography>
                </Tooltip>
              </Tooltip>
              <Typography className="award-year">
                {selectedAward.year}
              </Typography>
            </Card>
          </div>
          <div className="view-award-message">{selectedAward.description}</div>
        </div>
      }
      button1={CANCEL_TEXT}
      cancelButtonId="view-award-cancel-btn"
      button1Action={() => handleClose()}
    />
  );
};

ViewAward.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  selectedAward: PropTypes.any.isRequired,
};

export default ViewAward;
